import './skeleton-table.scss';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const SkeletonTable = () => {

    return (
        <div className='skeleton-table'>
            <Grid container spacing={1} className='row'>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
            </Grid>
            <Grid container spacing={1} className='row'>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
            </Grid>
            <Grid container spacing={1} className='row'>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
            </Grid>
            <Grid container spacing={1} className='row'>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={4}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
            </Grid>
        </div >
    );
}